import * as React from 'react';
import Button from 'react-scale/components/ui/button';
import Modal from 'react-scale/components/ui/modal';

const GradualRegistrationButton = () => {
  const [isRegisterModalOpen, setIsRegisterModalOpen] = React.useState(false);
  const handleRegisterClick = () => {
    setIsRegisterModalOpen(true);
  };
  return (
    <>
      <Button text="Register Now" variant="transformX" onClick={handleRegisterClick} />
      <Modal open={isRegisterModalOpen} setOpen={setIsRegisterModalOpen}>
        <div className="w-screen h-screen md:w-[700px] md:h-[700px] rounded-lg z-50">
          <iframe
            loading="eager"
            title="Transform X 2022"
            id="transform_x_2022_registration"
            src="https://exchange.scale.com/widgets/events/scale-transformx-2022/register"
            scrolling="yes"
            width="100%"
            height="100%"
            frameBorder="0"
          />
        </div>
      </Modal>
    </>
  );
};

export default GradualRegistrationButton;
